<app-upload-course-documents
  [courseItemId]="courseItemId"
  (closeModal)="onCloseModal()"
  (documentsUploaded)="onDocumentsUploaded()">
</app-upload-course-documents>

